<template>
    <div class="component-header text-left">
        <ul :class="`${isMobile? '' : 'nav justify-content-around'}`">
            <li>
                <b class="d-block">Aereoporto</b>
                <span>{{search.aereoporto? search.aereoporto.label : ''}}</span>
            </li>
            <li>
                <b class="d-block">Partenza</b>
                <span class="text-uppercase nowrap">{{departureFormatted}}</span>
            </li>
            <li>
                <b class="d-block">Passeggeri:</b>
                <span class="nowrap">{{summaryText}}</span>
            </li>
            <li>
                <div>
                    <a class="after-icon-pen pr-0" href="javascript:void(0)" @click="onClickModify">Modifica</a>
                </div>
            </li>
        </ul>
        <modal-change-search ref="modalChangeSearch" @change="onChange"/>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ModalChangeSearch from '../modals/ModalChangeSearch'

import {longDateFormatter} from '../../../../../utils/formatter'
import AnalyticEvents from '../../../../common/AnalyticEvents'
import MobileDetector from '../../../../common/MobileDetector'

export default {
  name: 'Header',
  mixins: [AnalyticEvents, MobileDetector],
  components: {ModalChangeSearch},
  props: {
    title: String
  },
  computed: {
    departureFormatted: function () {
      return longDateFormatter(this.search.partenza)
    },
    search: function () {
      return this.getSearch()
    },
    adults: function () {
      return this.getAdultsCounter()
    },
    childs: function () {
      return this.getChildsCounter()
    },
    summaryText: function () {
      let text = ''
      const {camere} = this.search
      const {adults, childs} = this
      if (camere && camere.length > 0) {
        text += camere.length + (camere.length === 1 ? ' camera: ' : ' camere: ')
        text += adults + (adults === 1 ? ' adulto' : ' adulti')
        if (childs > 0) {
          text += ', ' + childs + (childs === 1 ? ' bambino' : ' bambini')
        }
      }
      return text
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'getAdultsCounter', 'getChildsCounter']),
    onClickModify: function () {
      this.trackResultExperienceModifica()
      this.$refs.modalChangeSearch.open()
    },
    onChange: function (value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style scoped>
    .after-icon-pen::after {
        right: -20px;
    }
</style>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/experience/layout/Header.vue